import { render, staticRenderFns } from "./ModalUploadArquivo.vue?vue&type=template&id=89beccfe"
import script from "./ModalUploadArquivo.vue?vue&type=script&lang=js"
export * from "./ModalUploadArquivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports